import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Text } from "../UI";
import { useTheme } from "styled-components";
import { format } from "date-fns";
import { he } from "date-fns/locale";
import { StatusLabel, getStatusColor, CircleDiv, getStatusTextColor } from "./Common";
import remarkImg from "../assets/img/remark.svg";
import envelopeImg from "../assets/img/envelope.svg";
import { useMobile } from "../utils/mobile";
import envelopeBoldImg from "../assets/img/envelopeBold.svg";


const RepairPagesItem = ({
  message,
  selected,
  handleMessageSelected,
  newMsg,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("applies");
  const isMobile = useMobile();

  return (
    <div
      style={{
        border: isMobile ? "none" : !!newMsg
          ? `1px solid ${theme.color.palePrimary}`
          : `1px solid ${theme.color.gray30}`,
        padding: isMobile ? "0 20px" : "0px 15px",
        borderRadius: 10,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: isMobile ? 0 : 10,
        cursor: "pointer",
        gap: isMobile ? 10 : 20,
      }}
      onClick={() => handleMessageSelected(message, isMobile)}
    >
      <CircleDiv
        width={44}
        height={44}
        backgroundColor={selected ? theme.color.primary : theme.color.gray30}
      >
        <div
          style={{
            mask: `url(${selected ? envelopeBoldImg : envelopeImg}) no-repeat center / contain`,
            backgroundColor: selected
              ? theme.color.white
              : theme.color.gray100,
            width: 20,
            height: 20,
            cursor: "pointer",
            verticalAlign: "middle"
          }}
        ></div>
      </CircleDiv>
      <div style={{
        display: "flex",
        flexDirection: "row",
        borderBottom: isMobile && `1px solid ${theme.color.gray30}`,
        alignItems: "center",
        width: "100%",
      }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            marginTop: isMobile ? 14 : 10,
            cursor: "pointer",
          }}
        >
          <Text.BB
            style={{ cursor: "pointer", textAlign: "start", lineHeight: isMobile && "20px" }}
            color={
              message.WASREADFLAG !== "Y" && message.ZCOK_WASREADFLAG !== "Y"
                ? theme.color.navy
                : theme.color.gray90
            }
          >
            {!!message?.REPAIRNAME
              ? `${t("bedek")} / ${t("apply")}`
              : `${message.CUSTNOTETYPEDES} / ${t("apply")} ${message.CUSTNOTE}`}
          </Text.BB>
          <Text.SR color={theme.color.gray70} style={{ cursor: "pointer" }}>
            {format(
              message.CURDATE !== undefined
                ? new Date(message.CURDATE)
                : new Date(),
              "LLL dd/MM/yyyy",
              { locale: he }
            )}
          </Text.SR>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "cennter",
          alignItems: "center",
          gap: 12,
        }}
      >
        {(message.INCLUDEREMARKS === "Y" ||
          message.ZCOK_INCLUDEREMARKS === "Y") && (
            <img src={remarkImg} alt="remark" />
          )}
        <StatusLabel
          color={getStatusTextColor(message, theme)}
          backgroundColor={getStatusColor(message, theme)}
          borderColor={
            getStatusColor(message, theme) === "rgb(255,255,255)"
              ? theme.color.black
              : null
          }
        >
          {message.STATDES}
        </StatusLabel>
      </div>
    </div>
  );
};

export default inject(
  "tenantsStore",
  "repairPagesStore",
  "userStore"
)(observer(RepairPagesItem));
